import { render, staticRenderFns } from "./PlanetColorPicker.vue?vue&type=template&id=81aa1278&scoped=true"
import script from "./PlanetColorPicker.vue?vue&type=script&lang=js"
export * from "./PlanetColorPicker.vue?vue&type=script&lang=js"
import style0 from "./PlanetColorPicker.vue?vue&type=style&index=0&id=81aa1278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aa1278",
  null
  
)

export default component.exports